import LocationsPageHeader from "./locations-page-header";


export default LocationsPageHeader;